import { useTranslation } from "react-i18next"

const AccountDeletionInitiatedModal = ({ isOpen, onClose }) => {
  const { t, i18n } = useTranslation()

  if (!isOpen) return null

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
        padding: "20px",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#FFFFFF",
          borderRadius: "16px",
          padding: "40px",
          maxWidth: "500px",
          width: "100%",
          boxShadow: "0 25px 50px rgba(0, 0, 0, 0.25)",
          textAlign: "center",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
        dir={i18n.dir()}
      >
        {/* Modal Content */}
        <h2
          style={{
            fontFamily: '"Red Hat Display", sans-serif',
            fontSize: "24px",
            fontWeight: 600,
            color: "#303E4E",
            margin: "0 0 24px 0",
          }}
        >
          {t("accountManagement.modals.deletionInitiated.title")}
        </h2>
        
        <p
          style={{
            fontFamily: '"Red Hat Display", sans-serif',
            fontSize: "16px",
            color: "#6B7280",
            lineHeight: "1.6",
            margin: "0 0 32px 0",
          }}
        >
          {t("accountManagement.modals.deletionInitiated.description")}
        </p>

        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            width: "120px",
            height: "48px",
            background: "#8548A8",
            color: "#FFFFFF",
            border: "none",
            borderRadius: "12px",
            fontFamily: '"Red Hat Display", sans-serif',
            fontSize: "16px",
            fontWeight: 600,
            cursor: "pointer",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#7A4397"
            e.target.style.transform = "translateY(-1px)"
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "#8548A8"
            e.target.style.transform = "translateY(0)"
          }}
        >
          {t("accountManagement.modals.deletionInitiated.close")}
        </button>
      </div>
    </div>
  )
}

export default AccountDeletionInitiatedModal